import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import apiProvider from '../apiProvider/api';
import ReactTableComponent from '../table/ReactTableComponent';

const ProductEnquiryLayer = () => {
    const [enquiryData, setEnquiryData] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);

    const fetchData = async () => {
        setLoading(true);
        try {
            const result = await apiProvider.getProductEnquiries({
                page: pageIndex,
                limit: pageSize,
                search: searchTerm.trim()
            });

            if (result && result.status) {
                setEnquiryData(result.response?.data || []);
                setTotalPages(result.response?.totalPages || 0);
                setTotal(result.response?.total || 0);
            }
        } catch (error) {
            console.error("Error fetching product enquiry data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchData();
        }, 500); // 500ms debounce

        return () => clearTimeout(delayDebounceFn);
    }, [pageIndex, searchTerm]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setPageIndex(0);
    };

    const columns = useMemo(
        () => [
            {
                header: "S.No",
                size: 70,
                cell: (info) => pageIndex * pageSize + info.row.index + 1,
            },
            {
                header: "Product Name",
                accessorKey: "productId.productName",
                cell: (info) => info.row.original.productId?.productName || "N/A",
            },
            {
                header: "Customer Name",
                accessorKey: "name",
            },
            {
                header: "Phone Number",
                accessorKey: "phone",
            },
            {
                header: "Address",
                accessorKey: "address",
            },
            {
                header: "Message",
                accessorKey: "message",
            },
        ],
        [pageIndex]
    );

    const handleNextPage = () => {
        if (pageIndex + 1 < totalPages) setPageIndex((prev) => prev + 1);
    };

    const handlePreviousPage = () => {
        if (pageIndex > 0) setPageIndex((prev) => prev - 1);
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div style={{ position: "relative" }}>
                    <input
                        type="text"
                        className="form-control radius-8"
                        placeholder="Search..."
                        style={{ maxWidth: 350, minWidth: 200, paddingRight: '40px' }}
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <div className="search-icon" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}>
                        <Icon
                            icon="ic:baseline-search"
                            className="icon text-xl line-height-1"
                        />
                    </div>
                </div>
            </div>

            <div className="card-body p-24">
                <ReactTableComponent
                    data={enquiryData}
                    columns={columns}
                    pageIndex={pageIndex}
                    totalPages={totalPages}
                    onNextPage={handleNextPage}
                    onPreviousPage={handlePreviousPage}
                    totalRecords={total}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default ProductEnquiryLayer;
